"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultAsync = exports.MultSync = exports.MultEvent = exports.SingleEvent = exports.CurryProcess = exports.Curry = exports.filterXSS = exports.md5 = exports.errorBreak = exports.errorLog = exports.warnLog = exports.commonLog = undefined;

var _curry = require("./curry");

var _singleEvent = require("./singleEvent");

var _singleEvent2 = _interopRequireDefault(_singleEvent);

var _multEvent = require("./multEvent");

var _multEvent2 = _interopRequireDefault(_multEvent);

var _multAsync = require("./multAsync");

var _multAsync2 = _interopRequireDefault(_multAsync);

var _multSync = require("./multSync");

var _multSync2 = _interopRequireDefault(_multSync);

var _log = require("./log");

var _filterXSS = require("./filterXSS");

var _md = require("./md5");

var _md2 = _interopRequireDefault(_md);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/*
	intro : my function entry
	Author : chenchao
	Date : 2019-05-23
*/


exports.commonLog = _log.commonLog;
exports.warnLog = _log.warnLog;
exports.errorLog = _log.errorLog;
exports.errorBreak = _log.errorBreak;
exports.md5 = _md2.default;
exports.filterXSS = _filterXSS.filterXSS;
exports.Curry = _curry.Curry;
exports.CurryProcess = _curry.CurryProcess;
exports.SingleEvent = _singleEvent2.default;
exports.MultEvent = _multEvent2.default;
exports.MultSync = _multSync2.default;
exports.MultAsync = _multAsync2.default;